// App-wide replacement for window.alert().
//
//   await this.$appAlert({
//     type: "success" | "error" | "warning" | "info",
//     title: "Application submitted",
//     message: "Your application has been sent…",
//     highlight: "2872_2026",        // optional pill (e.g. an application number)
//     confirmText: "OK",
//   });
//
// Rendered by components/Common/AppAlert.vue (mounted once in App.vue).
// Returns a promise that resolves when the dialog is closed.
//
// This file must not import Vue: webpack 4 bundles it into the main.js module
// and compiles `import Vue from "vue"` here to `vue_runtime_esm[true]`, which
// crashes the production build on load. install() receives Vue instead and
// makes the state reactive in place.

export const alertState = {
  open: false,
  type: "info",
  title: "",
  message: "",
  highlight: "",
  confirmText: "OK",
  resolve: null,
};

export function showAlert(options) {
  const opts = typeof options === "string" ? { message: options } : options || {};
  // Close (and settle) any alert that's already showing.
  if (alertState.resolve) alertState.resolve();
  return new Promise((resolve) => {
    Object.assign(alertState, {
      type: "info",
      title: "",
      message: "",
      highlight: "",
      confirmText: "OK",
      ...opts,
      open: true,
      resolve,
    });
  });
}

export function closeAlert() {
  const resolve = alertState.resolve;
  alertState.open = false;
  alertState.resolve = null;
  if (resolve) resolve();
}

export default {
  install(VueCtor) {
    VueCtor.observable(alertState);
    VueCtor.prototype.$appAlert = showAlert;
  },
};
